import React, { memo, useRef } from 'react';
import { buildSvgEvents } from './svgCommonEvents';

// eslint-disable-next-line react/display-name
const SvgIconActivate = memo(
    ({ disabled = false, onClick, style, ...props }) => {
        const ref = useRef(null);

        return (
            <svg
                ref={ref}
                width={50}
                height={50}
                viewBox='0 0 50 50'
                fill={disabled ? '#cccccc' : ''}
                style={{
                    cursor: disabled ? 'default' : 'pointer',
                    ...style
                }}
                {...buildSvgEvents(ref, disabled, onClick)}
                {...props}
            >
                <path d='M25 0C11.19 0 0 11.19 0 25s11.19 25 25 25 25-11.19 25-25S38.81 0 25 0zm0 45.65C13.61 45.65 4.35 36.39 4.35 25S13.61 4.35 25 4.35c11.39 0 20.65 9.26 20.65 20.65S36.39 45.65 25 45.65z' />
                <path d='M18.33 30.1l-5.68-6.77-3.18 3.06 8.49 10.27 20.9-20.11-3.02-3.03z' />
            </svg>
        );
    }
);

export default SvgIconActivate;
